import styles from './ProjectFlow.module.scss'

interface FlowList {
  src: string
  alt: string
  title: string
  text: string
}

const flowLists: FlowList[] = [
  {
    src: '/images/LP/frontend/mailIcon.svg',
    alt: 'お問い合わせ',
    title: 'お問い合わせ',
    text: 'まずはお気軽にお問い合わせください。',
  },
  {
    src: '/images/LP/frontend/talkIcon.svg',
    alt: 'ヒアリング',
    title: 'ヒアリング',
    text: '抱えている課題やご要望について詳しくお話を伺います。',
  },
  {
    src: '/images/LP/frontend/discoveryIcon.svg',
    alt: '提案',
    title: '提案',
    text: 'お客さまのご要望にぴったりの提案をさせていただきます。',
  },
  {
    src: '/images/LP/frontend/unionIcon.svg',
    alt: 'ご契約',
    title: 'ご契約',
    text: '提案に合意いただけたら、ご契約手続きを行います。',
  },
  {
    src: '/images/LP/frontend/smilIcon.svg',
    alt: '開始',
    title: '開始',
    text: 'プロジェクトに合ったメンバーでチームを編成し、キックオフを行います。',
  },
]

const ProjectFlow: React.FC = () => {
  const flowList = flowLists.map(({ src, alt, title, text }) => (
    <li className={styles.steps} key={title}>
      <div className={styles.step}>
        <img className={styles.img} src={src} alt={alt} />
      </div>
      <div className={styles.textWrapper}>
        <p className={styles.stepTitle}>{title}</p>
        <p className={styles.text}>{text}</p>
      </div>
    </li>
  ))
  return (
    <section className={styles.project_flow} id="projectflow">
      <div className={styles.flow_panel}>
        <p className={styles.title}>プロジェクト開始までの流れ</p>
        <ul className={styles.flowList}>{flowList}</ul>
      </div>
    </section>
  )
}

export default ProjectFlow
